import { Col, Progress, Row } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import LoyalityLevelCard from "src/components/LoyalityLevelCard";
import { CardC, IconC } from "src/shared/components";
import useAuth from "src/shared/hooks/useAuth";
import useDirection from "src/shared/hooks/useDirection";
import useDomain from "src/shared/hooks/useDomain";
import useLocalization from "src/shared/hooks/useLocalization";
import useRequest from "src/shared/hooks/useRequest";
import RoleEnum from "src/shared/ts/enum/role.enum";
import useSWR from "swr";

const LoyalityLevelPageEndUser = () => {
  const { hasRole } = useAuth();
  const { push } = useHistory();
  const { t } = useTranslation();
  const { priceSeprator } = useDirection();

  const domain = useDomain();
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint();

  const { onCreate } = useRequest();

  const { getLanguage } = useLocalization();

  const isEndUser = hasRole(RoleEnum.end_user);

  const { data: endUserLoyalityLevel, isValidating: isValidatinglevel } =
    useSWR(
      isEndUser ? `/loyalty-level/select?lang=${getLanguage()?.language}` : null
    );

  const { data: endUsertotalPurshes, isValidating } = useSWR(
    isEndUser && endUserLoyalityLevel?.length
      ? `/product-order/user/totalPurshes`
      : null
  );

  return (
    <div>
      {isEndUser && endUserLoyalityLevel?.length > 1 ? (
        <CardC
          loading={isValidating && isValidatinglevel}
          style={{
            borderRadius: "10px",
            boxShadow: "0px 0px 17px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Row gutter={[0, 30]}>
            <Col span={24}>
              <Row gutter={[10, 10]}>
                <Col
                  span={24}
                  style={{ fontWeight: "bolder", fontSize: "20px" }}
                >
                  {t("User levels")}
                </Col>
                <Col span={24} style={{ fontWeight: 500, fontSize: "14px" }}>
                  <div style={{ display: "flex" }}>
                    <span>
                      <IconC
                        style={{ color: "#FFB038", fontSize: "20px" }}
                        type="ExclamationCircleOutlined"
                      />
                    </span>
                    <span style={{ margin: "0 8px" }}>
                      {t(
                        "Your user level is determined based on the total purchases you have made from the site"
                      )}
                    </span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <span>
                      <IconC
                        style={{ color: "#FFB038", fontSize: "20px" }}
                        type="ExclamationCircleOutlined"
                      />
                    </span>
                    <span style={{ margin: "0 8px" }}>
                      {t(
                        "Based on your user level, after each order, part of your order amount will be returned to your wallet as a gift"
                      )}
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="start" gutter={[10, 10]}>
                {endUsertotalPurshes && endUserLoyalityLevel
                  ? endUserLoyalityLevel?.map((item: any) => (
                      <LoyalityLevelCard
                        item={item}
                        findTrustCard={Number(endUsertotalPurshes?.pervId)}
                      />
                    ))
                  : null}
              </Row>
            </Col>
            {/* <Col span={24}>کل خریدهای شما :</Col> */}
            <Col xs={24} lg={14}>
              {/* <div>
                <h4>کل خریدهای شما :</h4>
              </div> */}
              <Progress
                strokeColor={{
                  from: "#108ee9",
                  to: "#87d068",
                }}
                strokeWidth={12}
                percent={Math.round(
                  Math.round(Number(endUsertotalPurshes?.totalprice) * 100) /
                    Number(endUsertotalPurshes?.nextPrice)
                )}
                status="active"
                // showInfo={false}
              />
              <div style={{ margin: "5px 0" }}>
                {/* <span style={{ fontWeight: "bold" }}>
                  {priceSeprator(endUsertotalPurshes?.totalprice)}
                </span>
                <span style={{ color: "rgb(170, 170, 170)" }}> از </span> */}
                <span style={{ color: "rgb(100, 100, 100)" }}>
                  <span> {t("By registering together")} </span>
                  <span style={{ fontWeight: "bold", color: "#000" }}>
                    {priceSeprator(
                      Number(endUsertotalPurshes?.nextPrice) -
                        Number(endUsertotalPurshes?.totalprice)
                    )}
                  </span>
                  <span>
                    {" "}
                    {t(
                      "Another order, you will be promoted to the next level"
                    )}{" "}
                  </span>
                </span>
              </div>
            </Col>
            <Col span={24}>
              {
                endUserLoyalityLevel?.find(
                  (item: any) => item?.id == Number(endUsertotalPurshes?.pervId)
                )?.description
              }
            </Col>
          </Row>
        </CardC>
      ) : isEndUser ? (
        <CardC
          loading={isValidating && isValidatinglevel}
          style={{
            borderRadius: "10px",
            boxShadow: "0px 0px 17px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h1> {t("The user level is not defined for you")} </h1>
        </CardC>
      ) : null}
    </div>
  );
};

export default LoyalityLevelPageEndUser;
